import { BreakdownTypes } from '@wix/cashier-express-checkout-widget/dist/src/types/PaymentBreakdown';
import { round } from './math.utils';
import { getDiscountsValue } from './discounts.utils';
export function getPaymentBreakdown(expressModel, discountsToAlignWith) {
  var _expressModel$priceSu, _expressModel$priceSu2, _expressModel$taxExem;
  const pricesIncludeTax = expressModel.pricesIncludeTax;
  const shipping = ((_expressModel$priceSu = expressModel.priceSummary) == null || (_expressModel$priceSu = _expressModel$priceSu.delivery) == null ? void 0 : _expressModel$priceSu.amount) ?? /* istanbul ignore next */'0';
  const tax = pricesIncludeTax ? '0' : ((_expressModel$priceSu2 = expressModel.priceSummary) == null || (_expressModel$priceSu2 = _expressModel$priceSu2.tax) == null ? void 0 : _expressModel$priceSu2.amount) ?? /* istanbul ignore next */'0';
  const discount = getTotalDiscount({
    discountsToAlignWith,
    taxExemptAmount: ((_expressModel$taxExem = expressModel.taxExemptPrice) == null ? void 0 : _expressModel$taxExem.amount) ?? '0',
    payNow: expressModel.priceSummary,
    giftCardAmount: expressModel.giftCardAmount,
    pricesIncludeTax
  });
  return {
    [BreakdownTypes.Shipping]: shipping,
    [BreakdownTypes.Tax]: tax,
    [BreakdownTypes.Discount]: discount
  };
}
function getTotalDiscount(_ref) {
  var _payNow$discount;
  let {
    discountsToAlignWith,
    taxExemptAmount,
    payNow,
    giftCardAmount,
    pricesIncludeTax
  } = _ref;
  const payNowDiscount = (payNow == null || (_payNow$discount = payNow.discount) == null ? void 0 : _payNow$discount.amount) ?? '0';
  const lineItemDiscounts = getDiscountsValue(discountsToAlignWith);
  const discountTotal = Number(payNowDiscount) + lineItemDiscounts;
  const giftCardTotal = (giftCardAmount == null ? void 0 : giftCardAmount.amount) ?? '0';
  const taxExemptTotal = pricesIncludeTax ? taxExemptAmount : '0';
  return round(Number(discountTotal) + Number(giftCardTotal) + Number(taxExemptTotal)).toString();
}
//# sourceMappingURL=getPaymentBreakdown.js.map